export default __webpack_public_path__ + "static/media/note1.0180ffe6.jpeg";